module.exports = __webpack_public_path__ + "static/media/google.6ab7b3a8.png";